import { render, staticRenderFns } from "./DocumentContentNew.vue?vue&type=template&id=9cb2cb74&scoped=true&"
import script from "./DocumentContentNew.vue?vue&type=script&lang=js&"
export * from "./DocumentContentNew.vue?vue&type=script&lang=js&"
import style0 from "./DocumentContentNew.vue?vue&type=style&index=0&id=9cb2cb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb2cb74",
  null
  
)

export default component.exports